'use strict';

(function() {
    /* jshint ignore:start */
    // modified version of https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign#Polyfill
    // Removed 'use strict'
    /* jshint ignore:end */
    if (typeof Object.assign !== 'function') {
        // Must be writable: true, enumerable: false, configurable: true
        Object.defineProperty(Object, 'assign', {
            value: function assign(target, varArgs) { // .length of function is 2
                if (target === null || target === undefined) {
                    throw new TypeError('Cannot convert undefined or null to object');
                }

                var to = Object(target);

                for (var index = 1; index < arguments.length; index++) {
                    var nextSource = arguments[index];

                    if (nextSource !== null && nextSource !== undefined) {
                        for (var nextKey in nextSource) {
                            // Avoid bugs when hasOwnProperty is shadowed
                            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                                to[nextKey] = nextSource[nextKey];
                            }
                        }
                    }
                }
                return to;
            },
            writable: true,
            configurable: true
        });
    }

    // Modified version of https://github.com/tc39/proposal-object-values-entries
    var reduce = Function.bind.call(Function.call, Array.prototype.reduce);
    var isEnumerable = Function.bind.call(Function.call, Object.prototype.propertyIsEnumerable);
    var concat = Function.bind.call(Function.call, Array.prototype.concat);

    if (!Object.values) {
        Object.values = function values(O) {
            return reduce(Object.keys(O), function(v, k) {
                return concat(v, typeof k === 'string' && isEnumerable(O, k) ? [O[k]] : []);
            }, []);
        };
    }

    if (!Object.entries) {
        Object.entries = function entries(O) {
            return reduce(Object.keys(O), function(e, k) {
                return concat(e, typeof k === 'string' && isEnumerable(O, k) ? [[k, O[k]]] : []);
            }, []);
        };
    }
})();